import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'src/services/redux/app/store';
import { _stopImpersonate } from 'src/services/redux/slices/auth/auth-slice';

const BANNER_HEIGHT = 44;

const ImpersonateBanner: React.FC = () => {
  const dispatch = useAppDispatch();
  const { impersonator, user } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (!impersonator) return;
    // Push all fixed-positioned elements (header, toolbar, etc.) down by banner height
    const styleId = 'impersonate-banner-style';
    let style = document.getElementById(styleId) as HTMLStyleElement | null;
    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      document.head.appendChild(style);
    }
    style.textContent = `
      body.header-fixed .header { top: ${BANNER_HEIGHT}px !important; }
      body.header-fixed .wrapper { padding-top: ${BANNER_HEIGHT}px; }
      body .toolbar-fixed .toolbar { top: calc(var(--kt-header-height, 65px) + ${BANNER_HEIGHT}px) !important; }
    `;
    return () => {
      style?.remove();
    };
  }, [impersonator]);

  if (!impersonator) return null;

  const handleStopImpersonate = () => {
    dispatch(_stopImpersonate());
    setTimeout(() => {
      window.location.href = '/admin';
    }, 200);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: BANNER_HEIGHT,
        zIndex: 9999,
        background: 'linear-gradient(135deg, #f6c23e 0%, #e0a800 100%)',
        color: '#1a1a2e',
        padding: '0 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        fontSize: 14,
        fontWeight: 600,
      }}
    >
      <span style={{ fontSize: 18 }}>👁️</span>
      <span>
        <strong>
          {user?.name} {user?.surname}
        </strong>{' '}
        kullanıcısının gözünden görüntülüyorsunuz
      </span>
      <button
        onClick={handleStopImpersonate}
        style={{
          marginLeft: 16,
          background: '#1a1a2e',
          color: '#f6c23e',
          border: 'none',
          borderRadius: 6,
          padding: '5px 16px',
          fontSize: 13,
          fontWeight: 700,
          cursor: 'pointer',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={(e) => {
          (e.target as HTMLButtonElement).style.background = '#2d2d4a';
        }}
        onMouseLeave={(e) => {
          (e.target as HTMLButtonElement).style.background = '#1a1a2e';
        }}
      >
        ✕ Çıkış Yap
      </button>
    </div>
  );
};

export default ImpersonateBanner;
